import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, query, orderBy, onSnapshot, limit } from 'firebase/firestore';
import Confetti from 'react-confetti';
import './Trivia.css';

const Trivia = () => {
  // --- CUSTOMIZE YOUR QUESTIONS HERE ---
  const questions = [
    {
      questionText: 'What is koralie favourite colour?',
      answerOptions: [
        { answerText: 'Red', isCorrect: false },
        { answerText: 'Yellow', isCorrect: true }, // <--- Set isCorrect: true for the right one
        { answerText: 'Blue', isCorrect: false },
        { answerText: 'Green', isCorrect: false },
      ],
    },
    {
      questionText: 'What is her absolute favorite food?',
      answerOptions: [
        { answerText: 'Bol Renverser', isCorrect: true },
        { answerText: 'Pizza', isCorrect: false },
        { answerText: 'Bomli Sec', isCorrect: false },
        { answerText: 'Sushi', isCorrect: false },
      ],
    },
    {
      questionText: 'What is her dream travel destination?',
      answerOptions: [
        { answerText: 'Paris', isCorrect: false },
        { answerText: 'Italy', isCorrect: true },
        { answerText: 'New York', isCorrect: false },
        { answerText: 'Tokyo', isCorrect: false },
      ],
    },
    {
      questionText: 'How does she take her coffee?',
      answerOptions: [
        { answerText: 'Black', isCorrect: false },
        { answerText: 'Mocachino', isCorrect: true },
        { answerText: 'Cappuccino', isCorrect: false },
        { answerText: 'She hates coffee', isCorrect: false },
      ],
    },
    {
      questionText: 'What is her hidden talent?',
      answerOptions: [
        { answerText: 'Singing', isCorrect: false },
        { answerText: 'Drawing', isCorrect: false },
        { answerText: 'Slam', isCorrect: true },
        { answerText: 'Dancing', isCorrect: false },
      ],
    },
  ];

  // --- STATE ---
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);
  const [playerName, setPlayerName] = useState('');
  const [gameStarted, setGameStarted] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);

  // Load Leaderboard
  useEffect(() => {
    const q = query(collection(db, 'trivia_scores'), orderBy('score', 'desc'), limit(10));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setLeaderboard(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  // Handle Answer Click
  const handleAnswerOptionClick = (isCorrect) => {
    if (isCorrect) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowScore(true);
      saveScore(score + (isCorrect ? 1 : 0)); // Save final score
    }
  };

  // Save Score to Firebase
  const saveScore = async (finalScore) => {
    if(playerName.trim() === '') return;
    await addDoc(collection(db, 'trivia_scores'), {
      name: playerName,
      score: finalScore,
      total: questions.length,
      timestamp: new Date()
    });
  };

  // Start Screen
  if (!gameStarted) {
    return (
      <div className="trivia-container">
        <div className="trivia-card start-screen">
          <h1>❓ Who Knows Koralie Best?</h1>
          <p>Test your friendship! Enter your name to start.</p>
          <input 
            type="text" 
            placeholder="Your Name" 
            value={playerName} 
            onChange={(e) => setPlayerName(e.target.value)} 
            className="name-input"
          />
          <button 
            onClick={() => { if(playerName) setGameStarted(true) }}
            className="start-btn"
          >
            Start Quiz
          </button>
        </div>

        {/* Mini Leaderboard Preview */}
        <div className="leaderboard-mini">
          <h3>🏆 Current Leaders</h3>
          {leaderboard.map((entry, index) => (
             <div key={entry.id} className="leader-row">
               <span>{index + 1}. {entry.name}</span>
               <span>{entry.score}/{entry.total}</span>
             </div>
          ))}
        </div>
      </div>
    );
  }

  // Result Screen
  if (showScore) {
    return (
      <div className="trivia-container">
        {score === questions.length && <Confetti recycle={false} numberOfPieces={500}/>}
        <div className="trivia-card score-section">
          <h2>Quiz Complete!</h2>
          <div className="big-score">
            {score} / {questions.length}
          </div>
          <p>
            {score === questions.length ? "Wow! You're a Koralie Expert! 🌟" : 
             score > 2 ? "Good job! You know her pretty well. 👍" : 
             "Oof... you might need to hang out more! 😅"}
          </p>
          
          <div className="leaderboard-section">
            <h3>🏆 Leaderboard</h3>
            {leaderboard.map((entry, index) => (
               <div key={entry.id} className={`leader-row ${entry.name === playerName ? 'highlight' : ''}`}>
                 <span>{index + 1}. {entry.name}</span>
                 <span>{entry.score}/{entry.total}</span>
               </div>
            ))}
          </div>
          
          <button onClick={() => window.location.reload()} className="restart-btn">Try Again</button>
        </div>
      </div>
    );
  }

  // Question Screen
  return (
    <div className="trivia-container">
      <div className="trivia-card">
        <div className="question-section">
          <div className="question-count">
            <span>Question {currentQuestion + 1}</span>/{questions.length}
          </div>
          <div className="question-text">{questions[currentQuestion].questionText}</div>
        </div>
        <div className="answer-section">
          {questions[currentQuestion].answerOptions.map((answerOption, index) => (
            <button 
              key={index} 
              onClick={() => handleAnswerOptionClick(answerOption.isCorrect)}
              className="answer-btn"
            >
              {answerOption.answerText}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Trivia;